import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";


const checkSessionCognito = () => {
  const poolData = {
    UserPoolId: process.env.REACT_APP_USER_POOL_ID,
    ClientId: process.env.REACT_APP_CLIENT_ID,
  };

  const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
  const cognitoUser = userPool.getCurrentUser();

  return new Promise((resolve, reject) => {
    try {
      cognitoUser.getSession((err, session) => {
        if (err) {
          reject({ code: 401, message: err.message || JSON.stringify(err) });
        }
        if (!session.isValid()) {
          reject({ code: 401, message: "Invalid Session" });
        }
        resolve({ code: 200 });
      });
    } catch (err) {
      reject({ code: 401, message: err.message || JSON.stringify(err) });
    }
  });
};

export default checkSessionCognito;
